import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
// import Github from "./Github"; // <-- Import ini telah saya hapus
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
// import Toolstack from "./Toolstack"; // Ini sudah dihapus sebelumnya

function About() {
  return (
    <>
      {" "}
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                Know Who <strong className="purple">I'M</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>

          <h1 className="project-heading">
            Powers & <strong className="purple">Abilities</strong>
          </h1>
          
          <p style={{ color: "white", textAlign: "center", fontSize: "1.1em" }}>
            Get ready! I have plenty of ammunition and weapons to help me on every battlefield.
          </p>

          {/* Ini adalah bagian Skillset Anda */}
          <Techstack />

          {/* <Github /> */} {/* <-- Bagian ini telah saya hapus */}
        </Container>
      </Container>
    </>
  );
}

export default About;